module.exports = __webpack_public_path__ + "static/media/footerbackground.2d8ac17d.jpg";